import { Button, Flex, Icon, Spinner, Text } from '@wyz/ui';
import { Link } from 'react-router';
import { Trans } from '~/common/context';
import { IUserCustomer } from '~/common/types';
import { useManageWcwCart } from '~/purchase/api';

type Props = { customer?: IUserCustomer };

function WcwCartStatus({ customer }: Props) {
  const wcwCart = useManageWcwCart({
    context: { customerId: customer?.id as string },
    get: { enabled: true },
  });
  const isCartFetched = wcwCart.get.isSuccess && wcwCart.get.isFetched;
  const items = wcwCart.get.data?.data.items ?? [];

  return (
    <Flex className='space-x-1'>
      <div className='bg-white p-1 rounded-1' style={{ height: '2.5rem' }}>
        <div className='fw-semi-bold fs-xxs'>
          <Trans i18nKey='app.purchase.cart_page.in_your_cart' />
        </div>
        {isCartFetched && items.length ? (
          <Text color='secondary' heading='xs' id='cart-items-count'>
            <Trans
              i18nKey='app.purchase.cart_count'
              values={{
                referenceCount: items.length,
                productCount: items.reduce(
                  (acc, item) => acc + item.quantity,
                  0,
                ),
              }}
            />
          </Text>
        ) : wcwCart.get.isProcessing ? undefined : (
          <div className='fs-xs text-title-color' data-cy='cart-items-count'>
            <Trans i18nKey='app.purchase.empty_cart' />
          </div>
        )}
      </div>
      <Button
        id='check-cart'
        variant='primary'
        size='md'
        as={Link}
        to='/purchase/wcw/cart'
        disabled={!customer?.purchaseSearchable}
      >
        {wcwCart.get.isProcessing ? (
          <Spinner style={{ width: 20, height: 20 }} />
        ) : (
          <div className='position-relative'>
            <Icon icon='shopping-cart' size='xs' />
            {Boolean(items.length) && (
              <div
                className='position-absolute bg-blue-secondary rounded-circle'
                style={{
                  left: '100%',
                  top: 0,
                  width: '0.475rem',
                  height: '0.475rem',
                }}
              ></div>
            )}
          </div>
        )}
      </Button>
    </Flex>
  );
}

export default WcwCartStatus;
